@if (revision) {
<section class="small-12 medium-6 columns pia-fullPreviewBlock-content">
  <div
    id="printRevision"
    class="container pia-fullPreviewContainerBlock pia-mainContainerBlock"
  >
    <div class="pia-fullPreviewBlock-data">
      <div class="pia-fullPreviewBlock-actions hide-for-print">
        <div>
          <button type="button" (click)="printRevision('printRevision')">
            <fa-icon [icon]="faPrint"></fa-icon>
            <div>{{ "summary.actions.print" | translate }}</div>
          </button>
        </div>
        <div>
          <button type="button" (click)="exportJson()">
            <fa-icon [icon]="faDownload"></fa-icon>
            <div>{{ "homepage.cards.item.tools.export" | translate }}</div>
          </button>
        </div>
        @if ( ['author', 'validator', 'evaluator'].indexOf(editMode[0]) >= 0 ||
        editMode === 'local' ) {
        <div>
          <button type="button" (click)="restoreRevision()">
            <fa-icon [icon]="faRefresh"></fa-icon>
            <div>{{ "summary.revision.restore_version" | translate }}</div>
          </button>
        </div>
        }
      </div>
      <header class="pia-fullPreviewBlock-header">
        <div>
          <span class="pia-icons pia-icon-white-preview"></span>
          <div>{{ "pia.header.preview" | translate }}</div>
        </div>
        <div class="pia-fullPreviewBlock-header-title">
          <h1>{{ "summary.preview_title" | translate }}</h1>
          <h2>{{ "summary.preview_subtitle" | translate }}</h2>
          <div class="pia-fullPreviewBlock-header-data">
            <div>
              <div>
                <div>
                  {{ "homepage.cards.placeholder_pia_name" | translate }} :
                </div>
                <div>
                  <strong>{{ export.pia.name }}</strong>
                </div>
              </div>
              <div>
                <div>{{ "summary.preview_edition" | translate }} :</div>
                <div>
                  {{ showUserRole(export.pia, "author", "author_name") }}
                </div>
              </div>
              <div>
                <div>{{ "summary.preview_evaluation" | translate }} :</div>
                <div>
                  {{ showUserRole(export.pia, "evaluator", "evaluator_name") }}
                </div>
              </div>
              <div>
                <div>{{ "summary.preview_validation" | translate }} :</div>
                <div>
                  {{ showUserRole(export.pia, "validator", "validator_name") }}
                </div>
              </div>
              @if (this.authService.state) {
              <div>
                <div>{{ "summary.preview_guests" | translate }} :</div>
                <div>{{ showUserRole(export.pia, "guest", null) }}</div>
              </div>
              }
            </div>
            <div>
              <div>
                <div>{{ "summary.preview_status" | translate }} :</div>
                <div>
                  {{ piaService.getStatusName(export.pia.status) | translate }}
                </div>
              </div>
              <div class="pia-fullPreviewBlock-header-progressBar">
                <div>{{ export.pia.progress }}%</div>
                <progress
                  max="100"
                  value="{{ export.pia.progress }}"
                ></progress>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div class="row" id="pia-full-content">
        <div class="small-12 medium-12 columns">
          <div>
            <!-- CONTEXT + FUNDAMENTAL PRINCIPLES + RISKS -->
            @if (allData) {
            <div
              ng-class="{'text-success': model.copied, 'text-danger': !model.copied}"
              ng-copy="events.onCopy($event)"
            >
              @for (section of this.data.sections; track section) {
              <div>
                @if (section.id !== 4 && allData[section.id]) {
                <div class="fadeIn section-{{ section.id }} pagebreak">
                  @for (item of section.items; track item) {
                  <div>
                    @if ( item.evaluation_mode !== '' &&
                    allData[section.id][item.id] ) {
                    <div>
                      <div
                        [className]="
                          'pia-fullPreviewBlock-headline headline' + section.id
                        "
                      >
                        <div class="pia-fullPreviewBlock-headline-title">
                          <h1>{{ section.title | translate }}</h1>
                          <h2>{{ item.title | translate }}</h2>
                        </div>
                      </div>
                      <div class="databox">
                        <!-- Measures -->
                        @if (item.is_measure) {
                        <div>
                          @if ( allData[section.id][item.id].length > 0) { @for
                          ( measure of allData[section.id][item.id] ; track
                          measure) {
                          <div>
                            <h3 [innerHTML]="measure.title"></h3>
                            <div
                              [innerHTML]="
                                measure.content | translate | safeHtml
                              "
                            ></div>
                            <br />
                            <!-- Measures' evaluations -->
                            @if (measure.evaluation) {
                            <div class="evaluationbox">
                              <p>
                                <strong class="evaluationValue"
                                  >{{ "evaluations.title" | translate }} :
                                  {{
                                    measure.evaluation.title | translate
                                  }}</strong
                                >
                                <br />
                                @if ( measure.evaluation.action_plan_comment ) {
                                <span>
                                  <strong
                                    >{{
                                      "evaluations.action_plan_comment"
                                        | translate
                                    }}
                                    :<br /></strong
                                  ><span
                                    style="font-weight:400;"
                                    [innerHTML]="
                                      measure.evaluation.action_plan_comment
                                        | safeHtml
                                    "
                                  ></span>
                                  <br />
                                </span>
                                } @if ( measure.evaluation.evaluation_comment )
                                {
                                <span>
                                  <strong
                                    >{{
                                      "evaluations.evaluation_comment"
                                        | translate
                                    }}
                                    :<br /></strong
                                  ><span
                                    style="font-weight:400;"
                                    [innerHTML]="
                                      measure.evaluation.evaluation_comment
                                        | safeHtml
                                    "
                                  ></span>
                                  <br />
                                </span>
                                }
                              </p>
                            </div>
                            }
                          </div>
                          } } @else {
                          {{ "summary.preview_no_data" | translate }}
                          }
                        </div>
                        }
                        <!-- Questions -->
                        @if (item.questions) {
                        <div>
                          @for (question of item.questions; track question) {
                          <div>
                            @if (allData[section.id][item.id][question.id]) {
                            <h3 [innerHTML]="question.title | translate"></h3>
                            @if ( allData[section.id][item.id][question.id]
                            .content &&
                            allData[section.id][item.id][question.id]
                            .content.length > 0 ) {
                            <div
                              [innerHTML]="
                                allData[section.id][item.id][question.id]
                                  .content
                                  | translate
                                  | safeHtml
                              "
                            ></div>
                            } @if ( allData[section.id][item.id][question.id]
                            .evaluation ) {
                            <div class="evaluationbox">
                              <br />
                              <p>
                                <strong class="evaluationValue"
                                  >{{ "evaluations.title" | translate }} :
                                  {{
                                    allData[section.id][item.id][question.id]
                                      .evaluation.title | translate
                                  }}</strong
                                >
                                <br />
                                @if ( allData[section.id][item.id][question.id]
                                .evaluation.action_plan_comment ) {
                                <span>
                                  <strong
                                    >{{
                                      "evaluations.action_plan_comment"
                                        | translate
                                    }}
                                    :<br /></strong
                                  ><span
                                    [innerHTML]="
                                      allData[section.id][item.id][question.id]
                                        .evaluation.action_plan_comment
                                        | safeHtml
                                    "
                                  ></span>
                                  <br />
                                </span>
                                } @if (
                                allData[section.id][item.id][question.id]
                                .evaluation.evaluation_comment ) {
                                <span>
                                  <strong
                                    >{{
                                      "evaluations.evaluation_comment"
                                        | translate
                                    }}
                                    :<br /></strong
                                  ><span
                                    [innerHTML]="
                                      allData[section.id][item.id][question.id]
                                        .evaluation.evaluation_comment
                                        | safeHtml
                                    "
                                  ></span>
                                  <br />
                                </span>
                                }
                                <!-- Gauges' values -->
                                @if ( allData[section.id][item.id][question.id]
                                .evaluation.gauges &&
                                allData[section.id][item.id][question.id]
                                .evaluation.gauges.seriousness > 0 ) {
                                <span>
                                  <span
                                    [innerHTML]="
                                      'evaluations.gauges.seriousness'
                                        | translate
                                    "
                                  ></span>
                                  {{
                                    "evaluations.gauges." +
                                      allData[section.id][item.id][question.id]
                                        .evaluation.gauges.seriousness
                                      | translate
                                  }}
                                  <br />
                                </span>
                                } @if (
                                allData[section.id][item.id][question.id]
                                .evaluation.gauges &&
                                allData[section.id][item.id][question.id]
                                .evaluation.gauges.likelihood > 0 ) {
                                <span>
                                  <span
                                    [innerHTML]="
                                      'evaluations.gauges.likelihood'
                                        | translate
                                    "
                                  ></span>
                                  {{
                                    "evaluations.gauges." +
                                      allData[section.id][item.id][question.id]
                                        .evaluation.gauges.likelihood
                                      | translate
                                  }}
                                </span>
                                }
                              </p>
                            </div>
                            } }
                          </div>
                          }
                        </div>
                        }
                        <!-- Evaluations -->
                        @if ( allData[section.id][item.id]['evaluation_item'] )
                        {
                        <div class="evaluationbox">
                          <br />
                          <p>
                            <strong class="evaluationValue"
                              >{{ "evaluations.title" | translate }} :
                              {{
                                allData[section.id][item.id]["evaluation_item"]
                                  .title | translate
                              }}</strong
                            >
                            <br />
                            @if (
                            allData[section.id][item.id]['evaluation_item']
                            .action_plan_comment ) {
                            <span>
                              <strong
                                >{{
                                  "evaluations.action_plan_comment" | translate
                                }}
                                :<br /></strong
                              ><span
                                [innerHTML]="
                                  allData[section.id][item.id][
                                    'evaluation_item'
                                  ].action_plan_comment | safeHtml
                                "
                              ></span>
                              <br />
                            </span>
                            } @if (
                            allData[section.id][item.id]['evaluation_item']
                            .evaluation_comment ) {
                            <span>
                              <strong
                                >{{
                                  "evaluations.evaluation_comment" | translate
                                }}
                                :<br /></strong
                              ><span
                                [innerHTML]="
                                  allData[section.id][item.id][
                                    'evaluation_item'
                                  ].evaluation_comment | safeHtml
                                "
                              ></span>
                              <br />
                            </span>
                            } @if (
                            allData[section.id][item.id]['evaluation_item']
                            .gauges &&
                            allData[section.id][item.id]['evaluation_item']
                            .gauges.seriousness > 0 ) {
                            <span>
                              <span
                                [innerHTML]="
                                  'evaluations.gauges.seriousness' | translate
                                "
                              ></span>
                              {{
                                "evaluations.gauges." +
                                  allData[section.id][item.id][
                                    "evaluation_item"
                                  ].gauges.seriousness | translate
                              }}
                              <br />
                            </span>
                            } @if (
                            allData[section.id][item.id]['evaluation_item']
                            .gauges &&
                            allData[section.id][item.id]['evaluation_item']
                            .gauges.likelihood > 0 ) {
                            <span>
                              <span
                                [innerHTML]="
                                  'evaluations.gauges.likelihood' | translate
                                "
                              ></span>
                              {{
                                "evaluations.gauges." +
                                  allData[section.id][item.id][
                                    "evaluation_item"
                                  ].gauges.likelihood | translate
                              }}
                            </span>
                            }
                          </p>
                        </div>
                        }
                      </div>
                    </div>
                    }
                  </div>
                  }
                </div>
                }
              </div>
              }
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
}
